import { Col, Row, Card, CardBody } from 'reactstrap';
import React, { useEffect, useMemo } from 'react';
import { getIncidentsQuery } from '../../../slices/dataProviders/thunk';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { useDispatch } from 'react-redux';

const IncidentsList = () => {
	const columns = useMemo(
		() => [
			{
				header: 'Región',
				accessorKey: 'region_centro',
				dataType: 'multi-select',
			},
			{
				header: 'Barrio',
				accessorKey: 'barrio_centro',
				dataType: 'multi-select',
			},
			{
				header: 'Establecimiento',
				accessorKey: 'nombre_centro',
				dataType: 'multi-select',
			},
			{
				header: 'Titular',
				accessorKey: 'titular_centro',
				dataType: 'multi-select',
			},
			{
				header: 'Código SIEP',
				accessorKey: 'siep_code',
				dataType: 'multi-select',
			},
			{
				header: 'Estado',
				accessorKey: 'estado',
				dataType: 'multi-select',
				Cell: ({ row }) => {
					let status = row.original.estado;
					let bgColor = status === 'Activo' ? '#d7f2e4' : '#ffe3dc';
					let txColor = status === 'Activo' ? '#45cc86' : '#f06448';
					return (
						<div>
							<span
								className={`badge`}
								style={{ backgroundColor: bgColor, color: txColor }}
							>
								{status ? status : '-'}
							</span>
						</div>
					);
				},
			},
			{
				header: 'Sensor',
				accessorKey: 'sensor_name',
				dataType: 'multi-select',
			},
			{
				header: 'Inicio',
				accessorKey: 'start',
				dataType: 'datetime',
			},
			{
				header: 'Fin',
				accessorKey: 'end',
				dataType: 'datetime',
			},
		],
		[]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						<CardBody>
							<ODataGrid
								getDataFunc={getIncidentsQuery}
								columns={columns}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								defaultPageSize={20}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default IncidentsList;
